import React from 'react';
import { useStyletron } from 'baseui';
import isNil from 'lodash/isNil';
import { FrameTimeInput, SpeedSelect, VolumeSlider } from '../../../../common/player-controls';
import useAnalyticsForVideoLabelling from '../../../labelling/components/frames-control-panel/analytics/useAnalyticsForVideoLabelling';
import { TimeDisplayMode } from '../../../types';
import { useFrameTimeState } from '../../hooks/use-frame-time-state';
import { BUTTON_SIZE, SPEED_OPTIONS } from './constants';
import { TimelineZoom } from './timeline-zoom';
type MediaSettingsProps = {
  playSpeed: number;
  setPlaySpeed: (speed: number) => void;
  mediaVolume?: number;
  onMediaVolumeChange?: (volume: number) => void;
  timeDisplayMode: TimeDisplayMode;
  setTimeDisplayMode: (timeDisplayMode: TimeDisplayMode) => void;
  currentFrame: number;
  maxFrames: number;
  frameRate: number | null | undefined;
  onFrameChange: (frame: number) => void;
  isMultiVideoIndex: boolean;
};
export const MediaSettings = ({
  playSpeed,
  setPlaySpeed,
  mediaVolume,
  onMediaVolumeChange,
  timeDisplayMode,
  setTimeDisplayMode,
  currentFrame,
  maxFrames,
  frameRate,
  onFrameChange,
  isMultiVideoIndex
}: MediaSettingsProps) => {
  const [css, theme] = useStyletron();
  const {
    sendEventVideoFrameNumberInput
  } = useAnalyticsForVideoLabelling();
  const {
    currentValue,
    totalValue,
    label,
    toggleLabel,
    isError,
    currentFrameLocalNumber,
    handleToggle,
    handleFrameTimeChange
  } = useFrameTimeState({
    currentFrame,
    maxFrames,
    frameRate,
    timeDisplayMode,
    setTimeDisplayMode,
    onFrameChange
  });
  const divider = <div className={css({
    width: theme.sizing.scale0,
    height: theme.sizing.scale850,
    backgroundColor: theme.colors.borderOpaque
  })} />;
  return <div className={css({
    display: 'flex',
    alignItems: 'center',
    gap: theme.sizing.scale700
  })}>
      <div className={css({
      display: 'flex',
      alignItems: 'center',
      gap: theme.sizing.scale500
    })}>
        <div className={css({
        display: 'flex',
        alignItems: 'center',
        gap: theme.sizing.scale300
      })}>
          {!isNil(mediaVolume) && onMediaVolumeChange && <VolumeSlider volume={mediaVolume} onVolumeChange={onMediaVolumeChange} iconSize={BUTTON_SIZE} />}
          <TimelineZoom />
        </div>
        {divider}
      </div>

      <div className={css({
      display: 'flex',
      alignItems: 'center',
      gap: theme.sizing.scale600
    })}>
        <SpeedSelect speed={playSpeed} onSpeedChange={setPlaySpeed} options={SPEED_OPTIONS} />

        {!isMultiVideoIndex && <FrameTimeInput value={currentValue} total={totalValue} label={label} toggleLabel={toggleLabel} onValueChange={handleFrameTimeChange} onToggle={handleToggle} onBlur={timeDisplayMode === TimeDisplayMode.FRAMES ? () => sendEventVideoFrameNumberInput({
        enteredFrame: currentFrameLocalNumber
      }) : undefined} error={isError} />}
      </div>
    </div>;
};